import { FormInput } from '../../../../component/input/InputStyle';
import GridComponent from '../../../../component/grid/GridComponent.component';
import { useFormik } from 'formik';
import FormLabel from '../../../../component/input/FormLabel.component';
import Grid from '@material-ui/core/Grid';
import { FormInterface } from '../../../../core/interfaces/form/Form';
import { Flag } from '../../../scheduleMaintenance/flags/interfaces/Flag';
import { ChangeEvent, useEffect, useState } from 'react';
import { getUserByName } from '../../../store/details/User.service';
import { formatTelephone } from '../../../../utils/format/FormatTelefone';
import SelectSearch, { IOption } from '../../../../component/select/SelectSearch';

export default function Form({
  handleSubmitForm,
  children,
  initialValues,
  setLoading,
  loading,
}: FormInterface<Flag>) {
  const { handleSubmit, handleChange, values } = useFormik<Flag>({
    initialValues: initialValues,
    onSubmit: (values) => {
      const user = listUsers.find((user) => user.value === selectUser.value);
      if (selectUser.value) {
        values.directorName = selectUser.label;
        values.directorAd = selectUser.value;
        values.directorEmail = user && user.email;
      } else {
        values.directorAd = '';
        values.directorName = '';
        values.directorEmail = '';
      }
      handleSubmitForm(values);
      setSelectUser({ label: '', value: '' });
      values.directorAd = '';
      values.directorName = '';
      values.directorEmail = '';
    },
  });

  const [listUsers, setListUsers] = useState<
    Array<{ label: string; value: string; email: string }>
  >([]);
  const [selectUser, setSelectUser] = useState<IOption>({ label: '', value: '' });

  useEffect(() => {
    handleInputChange(values.directorAd || '', true);
  }, []);

  const handleInputChange = async (value: string, setFirst?: boolean) => {
    setLoading && setLoading(true);
    if (value && value.length >= 3) {
      try {
        const response = await getUserByName(value);

        const listUsers: Array<{ label: string; value: string; email: string }> = [];

        if (response.data.users && response.data.users.length > 0) {
          response.data.users.forEach((u: any) => {
            listUsers.push({ label: u.cn, value: u.sAMAccountName.toUpperCase(), email: u.mail });
          });
          setListUsers(listUsers);
          if (setFirst) {
            setSelectUser({
              label: response.data.users[0].cn,
              value:
                response.data.users[0].sAMAccountName.toUpperCase() === value.toUpperCase()
                  ? value.toUpperCase()
                  : '',
            });
          }
        } else {
          setListUsers([]);
        }
      } catch (error) {
        setListUsers([]);
        console.error('Erro ao consultar usuário', error);
      }
    } else {
      setListUsers([]);
    }
    setLoading && setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <GridComponent justify='flex-start' alignItems='center' spacing={2}>
        <SelectSearch
          title='Diretor da Bandeira'
          data={listUsers}
          onChange={(event: any, selectOption: any) => {
            if (selectOption) {
              setSelectUser(selectOption);
            } else {
              setSelectUser({ label: '', value: '' });
            }
          }}
          onInputChange={handleInputChange}
          placeholder='Digite para pesquisar...'
          value={selectUser}
          request={loading}
          sm={12}
        />

        <FormLabel title='Dir. Telefone' sm={12} md={6}>
          <FormInput
            name='directorPhone'
            value={values.directorPhone}
            onChange={(e: ChangeEvent<any>) => {
              e.target.value = formatTelephone(e.target.value);
              handleChange(e);
            }}
            inputProps={{ maxLength: 16 }}
          />
        </FormLabel>

        <Grid item xs={12}>
          {children}
        </Grid>
      </GridComponent>
    </form>
  );
}
